export const getTextColor = (color: string): string => {
  const whiteTextColors = ["#4750F5", "#9057BD", "#63696F", "blurple", "charcoalBlack",
  "darkPurple"]
  return whiteTextColors.includes(color) ? "#FFFFFF" : "#000000";
};
